import { useState } from 'react';

import { AccordionBox } from './accordion-box';
import {
  HEADLINE,
  TEXT_CONTENT,
  ACCORDION_DATA,
} from './accordion-section-data';
import { Container, Title, Text } from './accordion-section.styles';

export const AccordionSection: React.FC = () => {
  const [isOpen, setIsOpen] = useState<Array<boolean>>([
    true,
    false,
    false,
    false,
  ]);

  const handleClick = (index: number): void => {
    setIsOpen((prevState) =>
      prevState.map((value, i) => (i === index ? !value : value))
    );
  };

  return (
    <Container>
      <Title size="xxlarge">{HEADLINE}</Title>
      <Text size="xlarge">{TEXT_CONTENT}</Text>
      {ACCORDION_DATA.map((data, index) => (
        <AccordionBox
          {...{ data }}
          isOpen={isOpen[index]}
          setIsOpen={() => handleClick(index)}
          key={data.question}
        />
      ))}
    </Container>
  );
};
